// Traductions du mode Lite : page « Edgy » (analyses + playbook).
// Les libellés métier (rapport, crédits, verrou bêta, formulaire playbook) viennent de t.edgy / t.playbook.
export const fr = {
  title: "Edgy",
  subtitle: "Ton coach IA lit tes trades à la lumière de ton playbook.",
  newAnalysis: "Nouvelle analyse",
  tabs: { analyses: "Analyses", playbook: "Playbook" },
  how: {
    title: "Comment ça marche",
    steps: [
      "Tu décris ta stratégie dans un playbook : marchés, sessions, setups, risque et comptes analysés.",
      "Tu lances une analyse sur un playbook : Edgy lit les trades de ses comptes et les compare à tes règles.",
      "Tu reçois un Edge Score, tes forces, tes fuites, les écarts au playbook et des actions pour la semaine.",
    ],
  },
  credits: {
    title: "Crédits du mois",
    refill: "Recharge le {date}",
    cooldown: "Prochaine analyse possible à {time}",
  },
  stats: {
    total: "Analyses réalisées",
    last: "Dernier Edge Score",
  },
  history: {
    title: "Historique",
    emptyText: "Lance ta première analyse avec le bouton « Nouvelle analyse ».",
    emptyLocked: "Passe au plan Max pour lancer ta première analyse.",
    open: "Ouvrir l'analyse",
  },
  lock: {
    playbookNote: "Le playbook reste disponible sur ton plan : prépare-le dès maintenant, il servira à ta première analyse.",
  },
  playbook: {
    listTitle: "Tes playbooks",
    count: "{count} playbook(s) actif(s)",
    newTitle: "Nouveau playbook",
    editTitle: "Modifier « {name} »",
  },
};

export const en: typeof fr = {
  title: "Edgy",
  subtitle: "Your AI coach reads your trades against your playbook.",
  newAnalysis: "New analysis",
  tabs: { analyses: "Analyses", playbook: "Playbook" },
  how: {
    title: "How it works",
    steps: [
      "You describe your strategy in a playbook: markets, sessions, setups, risk and analysed accounts.",
      "You run an analysis on a playbook: Edgy reads the trades of its accounts and compares them to your rules.",
      "You get an Edge Score, your strengths, your leaks, the gaps with your playbook and actions for the week.",
    ],
  },
  credits: {
    title: "Credits this month",
    refill: "Refills on {date}",
    cooldown: "Next analysis available at {time}",
  },
  stats: {
    total: "Analyses run",
    last: "Latest Edge Score",
  },
  history: {
    title: "History",
    emptyText: "Run your first analysis with the \"New analysis\" button.",
    emptyLocked: "Upgrade to the Max plan to run your first analysis.",
    open: "Open the analysis",
  },
  lock: {
    playbookNote: "The playbook stays available on your plan: set it up now, it will power your first analysis.",
  },
  playbook: {
    listTitle: "Your playbooks",
    count: "{count} active playbook(s)",
    newTitle: "New playbook",
    editTitle: "Edit \"{name}\"",
  },
};
